import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BotService } from '../bot.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Iconlibrarydialog, TemplateDialog,TemplateUpload } from '../bots.component';
import { find, pull } from 'lodash';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
@Component({
  selector: 'app-edit-bot',
  templateUrl: './edit-bot.component.html',
  styleUrls: ['./edit-bot.component.css', '../bots.component.css'],
})
export class EditBotComponent implements OnInit {
  editDetailsFormGroup: FormGroup;
  addtionalDetailsFormGroup: FormGroup;
  botId: string;
  botDetails: any;
  loginUserDetails: any;
  allPhoneNumbers: any;
  phoneNumber: string;
  webHookUrl: string;
  welcomeBanner: any;
  numberOfButtons: number[];
  welcomeBannerPreview: any;
  iconSelected: Array<boolean> = [];
  tags: string[] = [];
  tags_error = '';
  emailregex: RegExp =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  onSaveApiError = [];
  backSpaceTriggertoRemove = true;
  selectedFile: File | null = null;
  errorMessage: string = '';
  isDisabled: boolean = false;
  isChecked: boolean = false;
  faq_supported: boolean;
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  @ViewChild('tagInput') tagInputRef: ElementRef;
  constructor(
    private botService: BotService,
    private activatedRoute: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private _formBuilder: FormBuilder,
    private _matDialog: MatDialog,
    private router: Router
  ) {
    this.editDetailsFormGroup = this._formBuilder.group({
      displayName: ['', Validators.required],
      typeOfBot: '',
      phoneNumber: '',
      description: '',
    });
    this.addtionalDetailsFormGroup = this._formBuilder.group({
      customer_support_email:  ['', [Validators.required, Validators.pattern(this.emailregex)]],
      customer_support_phone: '',
      welcome_text: ['', Validators.required],
      allow_user_media: false,
      webhook_url: ['',[Validators.pattern('(https?://)([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?')]],
      persistentMenu: [''],
      buttons: this._formBuilder.array([]),
      support_link: ['',[Validators.pattern('https?://.+')]]
    });
  }

  ngOnInit(): void {
    this.loginUserDetails = JSON.parse(
      localStorage.getItem('loginUserDetails')
    );
    this.botId = this.activatedRoute.snapshot.params.id;
    this.getBotDetails();
    this.getWebHookUrlByBotId();
  }

  getErrorCustomerEmail() {
    return this.addtionalDetailsFormGroup.get('customer_support_email').hasError('required')
      ? ' Customer Support Email Id is required'
      : this.addtionalDetailsFormGroup.get('customer_support_email').hasError('pattern')
      ? 'Please Enter Valid Email ID'
      : '';
  }

  getErrorForLink() {
    return this.addtionalDetailsFormGroup.get('support_link').hasError('pattern') ? 'Please Enter Valid Url' : '';
  }

  getBotDetails() {
    this.botService.getBotConfigurationById(this.botId).subscribe(
      (res) => {
        this.botDetails = res.body;
        this.getBotDetailsByMerchantId();
        this.getBotLabels();
        this.faq_supported = this.botDetails.faq_supported;
        if(this.faq_supported){
          this.isChecked = true;
        }
      },
      (error) => {}
    );
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0];

    if (file) {
      if (
        file.type !==
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
        file.type !== 'application/vnd.ms-excel'
      ) {
        this.errorMessage = 'Please upload a valid Excel file (.xlsx or .xls).';
        this.isDisabled = true;
        this.selectedFile = null;
      } else if (file.size > 1 * 1024 * 1024) {
        this.errorMessage = 'File size must not exceed 1MB.';
        this.isDisabled = true;
        this.selectedFile = null;
      } else {
        if (this.selectedFile) {
          const dialogRef = this._matDialog.open(UpdateFaqDialog);
          dialogRef.afterClosed().subscribe((result) => {
            if (result === 'continue') {
              this.selectedFile = file;
              this.isDisabled = false;
              this.errorMessage = '';
            }
          });
        } else {
          this.errorMessage = '';
          this.selectedFile = file;
        }
      }
    }
  }

  onFileRemove() {
    this.selectedFile = null;
  }

  downloadTemplate() {
    const link = document.createElement('a');
    // link.href = 'https://dev-kluster-public-cdn.cgslate.com/bot-faqs/bot_faqs_template.xlsx';
    link.href = 'assets/bot-faqs/bot_faqs_template.xlsx';
    link.download = 'bot_faqs_template.xlsx';
    link.click();
  }

  onSlide(){
    this.isChecked = !this.isChecked;
  }

  getBotDetailsByMerchantId() {
    this.botService
      .getBotDetailsByMerchantId(this.loginUserDetails.merchant_id)
      .subscribe(
        (res) => {
          this.allPhoneNumbers = res.body.data;
          this.allPhoneNumbers.forEach((element) => {
            if (element.bot_id == this.botId) {
              this.phoneNumber = element.mobile;
            }
          });
          this.buildFormGroup();
        },
        (error) => {}
      );
  }

  getWebHookUrlByBotId() {
    this.botService.getWebHookUrl(this.botId).subscribe(
      (res) => {
        this.webHookUrl = res.body.webhook_url;
      },
      (error) => {
        if(error.code === 429) {
          let message = 'Too many requests. Please try again after some time.';
            if (error.error) {
              if (typeof error.error === 'string') {
                try {
                  const parsed = JSON.parse(error.error);
                  message = parsed.message || message;
                } catch (e) {}
              } else if (typeof error.error === 'object' && error.error.message) {
                message = error.error.message;
              }
            }
            this._snackBar.open(message, 'close', {
              duration: 3000,
              verticalPosition: this.verticalPosition,
              horizontalPosition: this.horizontalPosition,
            });
        }
      }
    );
  }

  buildFormGroup() {
    this.editDetailsFormGroup.patchValue({
      displayName: this.botDetails.name,
      typeOfBot: this.botDetails.category,
      phoneNumber: this.phoneNumber,
      description: this.botDetails.description,
    });
    // this.editDetailsFormGroup.disable();
    this.addtionalDetailsFormGroup.patchValue({
      customer_support_email: this.botDetails.customer_support_email,
      customer_support_phone: this.botDetails.customer_support_phone,
      welcome_text: this.botDetails.welcome_text,
      allow_user_media: this.botDetails.allow_user_media,
      welcome_banner:this.botDetails.welcome_banner,
      webhook_url: this.webHookUrl,
      support_link : this.botDetails.customer_support_url,
      persistentMenu: this.botDetails.persistent_menu !== null ?JSON.stringify(
        this.botDetails.persistent_menu.buttons.length
      ):"null"
    });
    this.addtionalDetailsFormGroup.controls.buttons = this._formBuilder.array(
      []
    );
    let formArray = this.addtionalDetailsFormGroup.controls.buttons as FormArray;
    this.botDetails.persistent_menu?.buttons.forEach((element) => {
      formArray.push(
        this._formBuilder.group({
          id: element.id.toString(),
          body: element.body,
          icon: element.icon?element.icon:"",
          reply: element.reply,
          //action_type: element.action_type?element.action_type: 'reply'
        })
      );
      if(element.icon){
        this.iconSelected.push(true);
      }else{
        this.iconSelected.push(false);
      }
      
    });
  }

  selectTemplate() {
    const templateDialogRef = this._matDialog.open(TemplateDialog, {
      data: this.botId,
    });
    templateDialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        this.welcomeBanner = result.data.image;
       let reader = new FileReader();
       reader.onload = (event: any) => {
        this.welcomeBannerPreview = event.target.result;
       }
       reader.readAsDataURL( this.welcomeBanner);
      }
    });
  }
  uploadTemplate(){
    document.getElementById('imageFileUpload').click();
  }
  fileUpload(event : any){
    let file = event.target.files[0];
    this.botService.updateProfilePhoto(this.botId, file).subscribe(
      (result) => {},
      (error) => {
        if (error.status === 200) {
          this._snackBar.open("Profile Photo Uploaded", 'close', {
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          });
          this.getBotDetails();
        }
        if (error.error.message) {
          this._snackBar.open(error.error.message, 'close', {
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          });
        }
      }
    );
      
  }
  selectTemplateFile(event : any){
    this.welcomeBanner = event.target.files[0];
    const templateDialogRef = this._matDialog.open(TemplateUpload, {
      data: { 
      ImageData: event}
    });
    templateDialogRef.afterClosed().subscribe((result)=>{
        if(result.data){
          this.welcomeBanner = result.data.image;
          let reader = new FileReader();
          reader.onload = (ev: any) => {
           this.welcomeBannerPreview = ev.target.result;
          }
          reader.readAsDataURL( this.welcomeBanner);
        }
    });
  }
  selectBotIcon(){
    const templateDialogRef = this._matDialog.open(BotIconSelect, {
      data: this.botId,
    });
    templateDialogRef.afterClosed().subscribe((result)=>{
      if(result.data){
        this.onclickOfImage(result.data.image);
      }
  });
  }
  async convertRelativeUriToFile(filePath, fileName, mimeType, cb) {
    let files = filePath.split('.')[filePath.split('.').length - 1];
    mimeType =
      mimeType ||
      `image/${files}`;
    const imageUrl = await fetch(filePath);
    const buffer = await imageUrl.arrayBuffer();
    cb(new File([buffer], fileName, { type: mimeType }));
  }
  onclickOfImage(event) {
    let fileName = event.target.value;

    const img = '/assets/profile-icons/' + fileName + '.png';
    this.convertRelativeUriToFile(img, 'profileIcon', null, (file) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);
      this.botService.updateProfilePhoto(this.botId, file).subscribe(
        (result) => {},
        (error) => {
          if (error.status === 200) {
            this._snackBar.open("Profile Photo Uploaded", 'close', {
              duration: 4000,
              horizontalPosition: 'end',
              verticalPosition: 'top',
            });
            this.getBotDetails();
          }
          if (error.error.message) {
            this._snackBar.open(error.error.message, 'close', {
              duration: 4000,
              horizontalPosition: 'end',
              verticalPosition: 'top',
            });
          }
        }
      );
    });
  }
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  // this function will trigger on selection of persistenct menu

  onPersistentMenuSelection(selectedValue?: string) {
    let formArray = this.addtionalDetailsFormGroup.controls.buttons as FormArray;
    if (selectedValue != 'null') {
      let buttonCount = parseInt(selectedValue) - formArray.controls.length;
      if (buttonCount > 0) {
        let formArray = this.addtionalDetailsFormGroup.controls.buttons as FormArray;
        this.numberOfButtons = [...Array(buttonCount).keys()];
        this.numberOfButtons.forEach((element, index) => {
          formArray.push(
            this._formBuilder.group({
              id: (formArray.value.length + 1).toString(),
              body: ['', Validators.required],
              icon: [''],
              reply: ['', Validators.required],
              //action_type:['reply'],
            })
          );
          this.iconSelected.push(false);
        });
      } else {
        let formArray = this.addtionalDetailsFormGroup.controls.buttons as FormArray;
        formArray.controls.splice(
          formArray.controls.length - Math.abs(buttonCount),
          Math.abs(buttonCount)
        );
        this.iconSelected.splice(
          formArray.controls.length - Math.abs(buttonCount),
          Math.abs(buttonCount)
        );
      }
    } else {
      this.addtionalDetailsFormGroup.controls.buttons = this._formBuilder.array([]);
      this.addtionalDetailsFormGroup.updateValueAndValidity();
    }
  }
  

  openIconPopup(index) {
    const iconLibraryDialogRef = this._matDialog.open(Iconlibrarydialog);
    iconLibraryDialogRef.afterClosed().subscribe((result) => {
      if (result.data) {
        let formGroup =
          this.addtionalDetailsFormGroup.controls.buttons['controls'][index];
        formGroup.controls.icon.patchValue(result.data);
        this.iconSelected[index] = true;
      }
    });
  }

  deleteIcon(index) {
    let formGroup =
      this.addtionalDetailsFormGroup.controls.buttons['controls'][index];
    formGroup.controls.icon.patchValue('');
    this.iconSelected[index] = false;
  }

  updateWebHookURL() {
    let request = {
      webhook_url: this.addtionalDetailsFormGroup.controls.webhook_url.value == ""?null: this.addtionalDetailsFormGroup.controls.webhook_url.value,
    };
    this.botService.updateWebhookUrl(this.botId, request).subscribe(
      (result) => {},
      (error) => {
        if (error.status === 200) {
          // this._snackBar.open('Webhook Url saved successfully', 'close', {
          //   duration:3000,
          //   horizontalPosition: this.horizontalPosition,
          //   verticalPosition: this.verticalPosition,
          // });
        }
        else if(error.error.message){
          this.onSaveApiError.push(error.error.message)
        }
        else {
          this.onSaveApiError.push("Something Went Wrong on updating Webhook Url")
        }
      }
    );
  }

  uploadWelcomeBanner() {
    this.botService
      .updateWelcomeBanner(this.botId, this.welcomeBanner)
      .subscribe(
        (res) => {},
        (error) => {
          if (error.status === 200) {
            // this._snackBar.open('Template uploaded succcessfully', 'close', {
            //   duration: 4000,
            //   horizontalPosition: 'end',
            //   verticalPosition: 'top',
            // });
          }
          else if (error.error.message) {
            this.onSaveApiError.push(error.error.message);
            // this._snackBar.open(error.error.message, 'close', {
            //   duration: 4000,
            //   horizontalPosition: 'end',
            //   verticalPosition: 'top',
            // });
          }
          else {
            this.onSaveApiError.push("Something Went Wrong on Uploading Banner");
          }
        }
      );
  }

  saveBotDetails() {
    let requestObject = {};
    requestObject = {
      customer_support_email: this.addtionalDetailsFormGroup.controls
        .customer_support_email.value
        ? this.addtionalDetailsFormGroup.controls.customer_support_email.value
        : null,
      customer_support_phone: this.addtionalDetailsFormGroup.controls
        .customer_support_phone.value
        ? this.addtionalDetailsFormGroup.controls.customer_support_phone.value
        : null,
      allow_user_media: this.addtionalDetailsFormGroup.controls.allow_user_media
        .value
        ? this.addtionalDetailsFormGroup.controls.allow_user_media.value
        : false,
      welcome_text: this.addtionalDetailsFormGroup.controls.welcome_text.value
        ? this.addtionalDetailsFormGroup.controls.welcome_text.value
        : null,
      customer_support_url: this.addtionalDetailsFormGroup.controls.support_link.value
        ? this.addtionalDetailsFormGroup.controls.support_link.value
        : null
    };
    if (this.welcomeBanner) {
      this.uploadWelcomeBanner();
    }

    this.updateWebHookURL();
    this.updateBotLabels();
    if (this.addtionalDetailsFormGroup.controls.persistentMenu.value !== '0'&& this.addtionalDetailsFormGroup.controls.persistentMenu.value !== 'null') {
      requestObject['persistent_menu'] = {
        buttons: this.addtionalDetailsFormGroup.controls.buttons.value,
      };
      requestObject['persistent_menu'].buttons.forEach((element,index) => {
        if(element.icon == ""){
          delete requestObject['persistent_menu'].buttons[index].icon
        }
      });
    } else {
      requestObject['persistent_menu'] = null;
    }
    requestObject['name'] = this.editDetailsFormGroup.controls.displayName.value;
    requestObject['description'] = this.editDetailsFormGroup.controls.description.value;
    if(this.isChecked){
      requestObject['faq_supported'] = true;
    } else {
      requestObject['faq_supported'] = false;
    }
    if(this.selectedFile){
      this.botService.uploadFaqs(this.botId, this.selectedFile).subscribe(
        (result) => {},
        (error) => {
          if (error.status === 200) {
            this.isDisabled = false;
            this.updateConfiguration(requestObject);
            this._snackBar.open('File successfully uploaded.', 'close', {
              duration: 4000,
              horizontalPosition: 'end',
              verticalPosition: 'top',
            });
          } else {
            if (error.error.message) {
              this.errorMessage = error.error.message;
            }
          }
        }
      );
    } else {
      this.updateConfiguration(requestObject)
    }
  }

  updateConfiguration(requestObject) {
    this.botService.updateBotConfiguration(this.botId, requestObject).subscribe(
      (response) => {},
      (error) => {
        if (error.status === 200) {
          // this._snackBar.open('Details saved successfully', 'close', {
          //   duration: 3000,
          //   horizontalPosition: 'end',
          //   verticalPosition: 'top',
          // });
          if(this.onSaveApiError.length>0){
            this._snackBar.open(this.onSaveApiError.toString(), 'close', {
              duration: 4000,
              horizontalPosition: 'end',
              verticalPosition: 'top',
            });
          }
          else {
            this.router.navigateByUrl('bots');
            this.openSubmitBotpopup();
          }
        }
        else if (error.error.message) {
          this._snackBar.open(error.error.message, 'close', {
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          });
        }
        else {
          this._snackBar.open("Something Went Wrong", 'close', {
            duration: 4000,
            horizontalPosition: 'end',
            verticalPosition: 'top',
          });
        }
        
      }
    );
    this.onSaveApiError = [];
  }

  openSubmitBotpopup(){
    this._matDialog.open(BotSubmitDialog, {
      data: this.botId,
    });
  }

  focusTagInput(): void {
    if(this.tagInputRef) this.tagInputRef.nativeElement.focus();
  }

  getBotLabels() {
    this.botService.getLabelsWithBotId(this.botId).subscribe(
      (res) => {
        this.tags = res.data;
      }
    )
  }
  removeTag(tag?: string): void {
    if (!!tag) {
      pull(this.tags, tag);
    } else {
      this.tags.splice(-1);
    }
  }
  onKeyUp(event: KeyboardEvent): void {
    const inputValue: string =this.tagInputRef.nativeElement.value;
    let words = inputValue.split(/\s+/);
    this.tags_error="";
    if(words.length >= 3){
        this.tagInputRef.nativeElement.value= words[0]+' '+words[1]
        this.tags_error = "A tag can have only two words"
      }
    if(event.code === 'Backspace'){
      this.tags_error=""
    }
    if (event.code === 'Backspace' && !inputValue) {
      if(this.backSpaceTriggertoRemove)
        this.removeTag();
      else this.backSpaceTriggertoRemove = true;
      return;
    } else {
      this.backSpaceTriggertoRemove = false;
      if (event.code === 'Enter'||event.code === 'NumpadEnter') {
        this.addTag(inputValue);
        this.backSpaceTriggertoRemove = true;
      }
    }
  }
  addTag(tag: string) {
    if (tag[tag.length - 1] === ',' || tag[tag.length - 1] === ' ') {
      tag = tag.slice(0, -1);
    }
    if(this.tags.includes(tag)){
      this.tags_error = "Same tag cannot be entered twice"
    }
    if(this.tags.length>=20){
      this.tags_error = "Maximum of 20 tags are allowed"
    }
    if (tag.length > 0 && !find(this.tags, tag) && !this.tags.includes(tag) && this.tags.length < 20) {
      this.tags.push(tag);
    }
    this.tagInputRef.nativeElement.value = '';
  }
  updateBotLabels(){
    const updatedTags = {
      data : this.tags
    }
    this.botService.updateLabelsWithBotId(this.botId, updatedTags).subscribe(
      (res) => {},
      (error) => {
        console.log(error);
        if(error.error.message){
          this.onSaveApiError.push(error.error.message)
          // this._snackBar.open(error.error.message, 'close', {
          //   duration : 4000,
          //   horizontalPosition : 'end',
          //   verticalPosition : 'top',
          // })
        }
        else if(error.status!=200){
          this.onSaveApiError.push("Something Went Wrong on Updating labels")
        }
      }
    );
  }

}


@Component({
  selector: 'bot-submit-dialog',
  templateUrl: 'bot-submit-dialog.html',
  styleUrls: ['edit-bot.component.css','../bots.component.css'],
})
export class BotSubmitDialog {
  constructor(public dialogRef: MatDialogRef<BotSubmitDialog>) {}

  closePopup() {
    this.dialogRef.close();
  }
}
@Component({
  selector: 'bot-picture',
  templateUrl: 'bot-icon-select.html',
  styleUrls: ['edit-bot.component.css','../bots.component.css'],
})
export class BotIconSelect {
  constructor(public dialogRef: MatDialogRef<BotIconSelect>) {}
   file: any;
  closePopup() {
    this.dialogRef.close();
  }
  onChangeIcon(event){
    this.file = event;
  }
  saveIcon(){
    this.dialogRef.close({
      event: 'close',
      data: {
        image: this.file,
      },
    });
  }
}

@Component({
  selector: 'app-update-faq-dialog',
  templateUrl: 'update-faq-dialog.html',
  styleUrls: ['./edit-bot.component.css']
})

export class UpdateFaqDialog {
  constructor(public dialogRef: MatDialogRef<UpdateFaqDialog>, private router: Router){

  }
  closePopUp(){
    this.dialogRef.close();
  }
  continueUpload(){
    this.dialogRef.close('continue');
  }
}